// @flow
import {__, includes, compose, pathOr, equals, startsWith} from 'ramda';

import type {SelectorType} from 'constants/flow/flowTypes';

/**
 * Determines is checkout page active
 * @type {SelectorType<boolean>}
 */
export const isCheckoutPage: SelectorType<boolean> = compose(
    includes(__, ['/checkout/onepage/', '/optimaxcheckout/amazon']),
    pathOr('', ['router', 'location', 'pathname']),
);

/**
 * Determines is success page active
 * @type {SelectorType<boolean>}
 */
export const isSuccessPage: SelectorType<boolean> = compose(
    startsWith('/checkout/onepage/success', __),
    pathOr('', ['router', 'location', 'pathname']),
);

/**
 * Determines is product page active
 * @type {SelectorType<boolean>}
 * @returns {boolean} flag
 */
export const isProductPage: SelectorType<boolean> = compose(
    equals(__, 'product'),
    pathOr('', ['routerInfo', 'page']),
);
